
export default class GalleryModelFactory {

    constructor(table) {
        this.table = table
    }

    newLayout() {
        // new data model below
        return {
            gallery: {
                mobile: {
                    columnCount: 2
                },
                desktop: {
                    columnCount: 3
                },
                data: {
                    image: {
                        field: this.imageFieldId()
                    },
                    title: {
                        field: this.primaryFieldId()
                    },
                    subTitle: {
                        field: this.selectFieldId()
                    },
                    body: {
                        field: this.textFieldId()
                    }
                }

            }
        }
    }

    imageFieldId() {
        return webase.utils.table.hasImageField(this.table) ? webase.utils.table.getImageField(this.table).id : ''
    }

    primaryFieldId() {
        return webase.utils.table.getPrimaryField(this.table).id
    }

    textFieldId() {
        return webase.utils.table.hasTextField(this.table) ? webase.utils.table.getTextField(this.table).id : ''
    }

    selectFieldId() {
        return webase.utils.table.hasSelectField(this.table) ? webase.utils.table.getSelectField(this.table).id : ''
    }
}